// Rounding rules for the Staff Payroll Generation employee popup.
//
// - Salary heads keep their paise (the generate SP returns day-prorated amounts
//   such as 3000.83), EXCEPT PF and ESI contributions, which are whole rupees.
// - Only the totals are rounded: Gross and Net to whole rupees. Deductions total
//   keeps paise.
// - Gross = round(sum of heads), NOT sum of rounded heads. Rounding each head first
//   was what pushed Gross/Net up by Rs 1-3 (up to 0.50 per head).
// - Net = round(unrounded gross - deductions), same formula as spGenerateCCPayRoll.

// PF / ESI heads by name: 'PF EMPLOYEE CONT.', 'ESI EMPLOYEE CONT.',
// 'PROVIDENT FUND(EMPLOYEE)', 'ESIC(EMPLOYEE)', ...
export const isPFESIHeadName = (name) => {
    const n = String(name || '').toUpperCase();
    return /\bPF\b/.test(n) || n.includes('PROVIDENT') || n.includes('ESI');
};

const toNumber = (v) => {
    const n = Number(v);
    return Number.isFinite(n) ? n : 0;
};

// Round to 2 decimals without float drift (1.005 -> 1.01).
export const roundPaise = (v) => Math.round((toNumber(v) + Number.EPSILON) * 100) / 100;

export const roundRupee = (v) => Math.round(toNumber(v));

// PF/ESI -> whole rupees, every other head -> paise.
export const normalizeHeadAmount = (headName, amount) =>
    isPFESIHeadName(headName) ? roundRupee(amount) : roundPaise(amount);

// amountOf(head) returns the current amount for a head row.
export const calcPayrollTotals = (earningHeads, deductionHeads, amountOf) => {
    const grossRaw = earningHeads.reduce((s, h) => s + toNumber(amountOf(h)), 0);
    const dedRaw   = deductionHeads.reduce((s, h) => s + toNumber(amountOf(h)), 0);
    return {
        gross:    roundRupee(grossRaw),
        totalDed: roundPaise(dedRaw),
        netPay:   roundRupee(grossRaw - dedRaw),
    };
};

// String form sent to spInsertSingleEmpSalary (amounts are DECIMAL(18,2) there).
export const toAmountString = (v) => roundPaise(v).toFixed(2);
